/* ==========================================================================
   IRON FIT — How It Works · Contact · mobile navigation

   The showroom is one unscrollable screen, so these sections arrive as
   full-screen panels rather than as scroll targets — same idea as the
   packages overlay, same back-bar and Escape to close.

   Everything below builds its own markup and wires itself to whatever nav
   links the page already has (#how, #contact), so the
   page's HTML needs nothing but the <link> and <script> tags.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__ifzSections) return;
  window.__ifzSections = 1;

  var WA = '96181923182';
  var WA_URL = 'https://wa.me/' + WA;
  var TEL = '+96181923182';

  var root = document.documentElement;

  /* ======================================================================
     COPY
     Prices, promises and answers are the ones already published on the
     site — kept in one place here so they only ever change once.
     ====================================================================== */

  var STEPS = [
    {
      n: '01',
      h: 'Choose your setup',
      p: 'Pick a complete package or a single machine. Every price you see is the <b>final</b> price — the machine, standard delivery and professional installation are already inside it. Nothing is added at the cart.'
    },
    {
      n: '02',
      h: 'We confirm on WhatsApp',
      p: 'A person answers — not a bot. We check your room, your floor and your access: building, lift, and how wide the stairway is. Anything unusual is agreed with you <b>before</b> the order is confirmed.'
    },
    {
      n: '03',
      h: 'We deliver and install',
      p: 'Our team brings it in, assembles it, calibrates it and tests it on site. You do not lift it, and you do not hire anyone else to put it together.'
    },
    {
      n: '04',
      h: 'You pay at the door',
      p: 'Cash on delivery. You pay only once the machine is standing in your home and tested. Nothing is charged online, and no card is needed to order.',
      ar: 'الدفع عند الاستلام'
    }
  ];

  var PROMISES = [
    { i: '🏷️', b: 'Final price',        s: 'No delivery or installation fee appears later.' },
    { i: '🚚', b: 'All Lebanon',         s: 'We deliver everywhere — $50 to $100 by region, charged once.' },
    { i: '🔧', b: 'Installed for you',   s: 'Assembled, calibrated and tested on site.' },
    { i: '💵', b: 'Cash on delivery',    s: 'Pay at the door — nothing charged online.' }
  ];

  var FAQ = [
    ['Is the price really final?',
     'Yes. Machine prices include the machine, standard delivery, professional installation, assembly, calibration and testing. <b>No delivery or installation fee is added at the cart or at checkout.</b>'],
    ['How do I pay?',
     'Cash on delivery — الدفع عند الاستلام. Nothing is charged online when you place the order, and you do not need a card.'],
    ['Is installation really included?',
     'Yes, on every machine and every package. Our team assembles the machine, calibrates it and tests it on site. Accessories ordered together with a machine ride along at no extra delivery charge.'],
    ['What exactly comes in each package?',
     'Each package lists its exact contents and its exclusions on its own card. Anything not on that list is not in the box.'],
    ['How are plates priced?',
     'Plates are <b>$3 per kg</b> on their own, in 2.5, 5, 10 and 20 kg sizes, and a plates-only order carries one $10 delivery charge for the whole order — never per plate. With a machine package they are charged at the better rate of <b>$2.50 per kg</b>.'],
    ['Do I need plates for the Compact Single-Stack?',
     'No. It has a built-in weight stack, so no loose plates are required.'],
    ['What access do you need to deliver?',
     'Tell us your area, your building and floor, whether there is a lift, and how wide the stairway is. If anything unusual is needed we discuss and agree it with you before confirming the order.'],
    ['Can I ask a question before ordering?',
     'Yes — message us on WhatsApp and a person will answer. Send your room dimensions if you are unsure about the space.']
  ];

  /* Inline so the panels never depend on an icon font or a sprite file. */
  var ICON = {
    wa: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm0 18.2c-1.5 0-3-.4-4.3-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2Zm4.6-6.1c-.3-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.4-3c-.3-.4 0-.5.1-.7l.4-.5c.1-.2.2-.3.3-.5v-.5L9.7 7.6c-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.5.1-.7.3-.2.3-.9.9-.9 2.1s.9 2.4 1 2.6c.1.2 1.8 2.8 4.3 3.9.6.3 1.1.4 1.5.5.6.2 1.2.2 1.6.1.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2l-.3-.2Z"/></svg>',
    tel: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .3 1.9.6 2.8a2 2 0 0 1-.4 2.1L8 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.5c.9.3 1.8.5 2.8.6a2 2 0 0 1 1.8 2.1Z"/></svg>',
    pin: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>'
  };

  /* ======================================================================
     BUILD
     ====================================================================== */

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function shell(id, tag, title, lead) {
    var s = el('section', 'ifs');
    s.id = id;
    s.setAttribute('role', 'dialog');
    s.setAttribute('aria-modal', 'true');
    s.setAttribute('aria-label', tag);

    s.innerHTML =
      '<div class="ifs__bar">' +
        '<button class="ifs__back" type="button"><b>&#8592;</b> Back to machines</button>' +
        '<span class="ifs__tag">' + tag + '</span>' +
      '</div>' +
      '<div class="ifs__inner">' +
        '<div class="ifs__head"><h2>' + title + '</h2><p>' + lead + '</p></div>' +
      '</div>';

    return s;
  }

  function buildHow() {
    var s = shell('how', 'How it works',
      'Four steps. <b>One price.</b>',
      'You are buying a machine that arrives standing, tested and paid for at your door. ' +
      'Here is exactly what happens between picking it and training on it.');

    var inner = s.querySelector('.ifs__inner');

    var ol = el('ol', 'hw');
    STEPS.forEach(function (st) {
      ol.appendChild(el('li', 'hw__step',
        '<span class="hw__n">' + st.n + '</span>' +
        '<h3 class="hw__h">' + st.h + '</h3>' +
        '<p class="hw__p">' + st.p + (st.ar ? '<b class="hw__ar">' + st.ar + '</b>' : '') + '</p>'
      ));
    });
    inner.appendChild(ol);

    inner.appendChild(el('hr', 'ifs__rule'));
    inner.appendChild(el('h3', 'ifs__sub', 'What is included, every time'));

    var grid = el('div', 'hwp');
    PROMISES.forEach(function (p) {
      grid.appendChild(el('div', 'hwp__i',
        '<i aria-hidden="true">' + p.i + '</i><b>' + p.b + '</b><span>' + p.s + '</span>'));
    });
    inner.appendChild(grid);

    inner.appendChild(el('hr', 'ifs__rule'));
    inner.appendChild(el('h3', 'ifs__sub', 'Questions'));

    var faq = el('div', 'faq');
    FAQ.forEach(function (q) {
      faq.appendChild(el('details', 'faq__q',
        '<summary>' + q[0] + '</summary><p class="faq__a">' + q[1] + '</p>'));
    });
    inner.appendChild(faq);

    return s;
  }

  function buildContact() {
    var s = shell('contact', 'Contact',
      'Talk to a person. <b>Before you buy.</b>',
      'Send your room size, your floor and your access and we will tell you straight ' +
      'whether a machine fits — including when the honest answer is a smaller one.');

    var inner = s.querySelector('.ifs__inner');

    var wrap = el('div', 'ct__wrap');

    /* ---- channels ---- */
    var left = el('div');
    left.appendChild(el('h3', 'ifs__sub', 'Reach us'));

    var ch = el('div', 'ct');
    ch.innerHTML =
      '<a class="ct__ch ct__ch--wa" href="' + WA_URL + '" target="_blank" rel="noopener">' +
        '<span class="ct__ic">' + ICON.wa + '</span>' +
        '<span class="ct__tx"><b>WhatsApp us</b><span>81 923 182 — a person answers, usually within minutes.</span></span>' +
        '<span class="ct__go" aria-hidden="true">&#8594;</span>' +
      '</a>' +
      '<a class="ct__ch" href="tel:' + TEL + '">' +
        '<span class="ct__ic">' + ICON.tel + '</span>' +
        '<span class="ct__tx"><b>Call 81 923 182</b><span>Prefer to speak? Ring the same number.</span></span>' +
        '<span class="ct__go" aria-hidden="true">&#8594;</span>' +
      '</a>' +
      '<div class="ct__ch">' +
        '<span class="ct__ic">' + ICON.pin + '</span>' +
        '<span class="ct__tx"><b>We deliver all Lebanon</b><span>Delivery and professional installation are included in the machine price.</span></span>' +
      '</div>';
    left.appendChild(ch);

    var chips = el('div', 'ctc');
    chips.innerHTML =
      '<span>Cash on <b>delivery</b></span>' +
      '<span>Installation <b>included</b></span>' +
      '<span>No card <b>needed</b></span>' +
      '<span>ironfitstore<b>.online</b></span>';
    left.appendChild(chips);

    /* ---- form ---- */
    var right = el('div');
    right.appendChild(el('h3', 'ifs__sub', 'Send your details'));

    var form = el('form', 'ctf');
    form.setAttribute('novalidate', '');
    form.innerHTML =
      '<div class="ctf__row">' +
        '<label for="ctfName">Your name <em>*</em></label>' +
        '<input id="ctfName" name="name" type="text" autocomplete="name" placeholder="Full name" required>' +
      '</div>' +
      '<div class="ctf__row">' +
        '<label for="ctfPhone">Phone <em>*</em></label>' +
        '<input id="ctfPhone" name="phone" type="tel" inputmode="tel" autocomplete="tel" placeholder="03 000 000" required>' +
      '</div>' +
      '<div class="ctf__row">' +
        '<label for="ctfArea">Area &amp; floor</label>' +
        '<input id="ctfArea" name="area" type="text" placeholder="e.g. Jounieh, 3rd floor, lift">' +
      '</div>' +
      '<div class="ctf__row">' +
        '<label for="ctfMsg">Your question</label>' +
        '<textarea id="ctfMsg" name="message" placeholder="Room is 2.4 m high — does the Smith machine fit?"></textarea>' +
      '</div>' +
      '<button class="ctf__send" type="submit">' + ICON.wa + '<span>Send on WhatsApp</span></button>' +
      '<p class="ctf__note">This opens WhatsApp with your details already written. ' +
      '<b>Nothing is sent or charged until you press send there.</b></p>';

    right.appendChild(form);

    wrap.appendChild(left);
    wrap.appendChild(right);
    inner.appendChild(wrap);

    /* ---- submit -> WhatsApp ---- */
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var f = form.elements;
      var bad = null;

      [['name', f.name], ['phone', f.phone]].forEach(function (pair) {
        var row = pair[1].closest('.ctf__row');
        var empty = !pair[1].value.trim();
        row.classList.toggle('is-bad', empty);
        if (empty && !bad) bad = pair[1];
      });

      if (bad) { bad.focus(); return; }

      var msg = 'Hello Iron Fit — from ironfitstore.online\n' +
                'Name: ' + f.name.value.trim() + '\n' +
                'Phone: ' + f.phone.value.trim();
      if (f.area.value.trim())    msg += '\nArea / floor: ' + f.area.value.trim();
      if (f.message.value.trim()) msg += '\nQuestion: ' + f.message.value.trim();

      window.open(WA_URL + '?text=' + encodeURIComponent(msg), '_blank', 'noopener');
    });

    /* Clear the error ring as soon as they start fixing it. */
    form.addEventListener('input', function (e) {
      var row = e.target.closest('.ctf__row');
      if (row) row.classList.remove('is-bad');
    });

    return s;
  }

  /* ======================================================================
     PANEL OPEN / CLOSE
     ====================================================================== */

  var panels = [];
  var lastFocus = null;

  function closeAll(skip) {
    panels.forEach(function (p) {
      if (p !== skip && p.classList.contains('is-open')) p.classList.remove('is-open');
    });
  }

  function openPanel(p) {
    lastFocus = document.activeElement;
    closeAll(p);
    closeMenu();
    root.classList.add('ifs-open');
    p.classList.add('is-open');
    p.scrollTop = 0;
    try { p.querySelector('.ifs__back').focus({ preventScroll: true }); } catch (e) {}
  }

  function closePanel(p) {
    p.classList.remove('is-open');
    if (!document.querySelector('.ifs.is-open')) root.classList.remove('ifs-open');
    if (lastFocus && lastFocus.focus) {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  function wirePanel(p) {
    panels.push(p);
    p.querySelector('.ifs__back').addEventListener('click', function () { closePanel(p); });
  }

  /* ======================================================================
     MOBILE MENU
     ====================================================================== */

  var menu = null;
  var burger = null;

  /* Every burger on the page, not just the header one. The packages overlay
     and the two panels carry their own now (see addOverlayBurger), and they
     all drive this one sheet, so they must all show the same open state. */
  function allBurgers() {
    return [].slice.call(document.querySelectorAll('.nav__burger'));
  }

  function closeMenu() {
    if (!menu) return;
    menu.classList.remove('is-open');
    allBurgers().forEach(function (b) {
      b.classList.remove('is-on');
      b.setAttribute('aria-expanded', 'false');
    });
  }

  function openMenu() {
    menu.classList.add('is-open');
    allBurgers().forEach(function (b) {
      b.classList.add('is-on');
      b.setAttribute('aria-expanded', 'true');
    });
  }

  /* ----------------------------------------------------------------------
     A menu button inside an overlay's own bar.

     The packages overlay (z-index 200) and the How It Works / Contact panels
     (220) both sit above the navbar (60), so the moment any of them opened
     the burger was buried and the menu was unreachable without backing out
     first. Each of those bars already has its back button on the left and
     nothing on the right, so the button goes there — no floating control and
     nothing to collide with.
     ---------------------------------------------------------------------- */
  function addOverlayBurger(bar) {
    if (!bar || bar.querySelector('.nav__burger')) return;
    var b = el('button', 'nav__burger nav__burger--over',
               '<span></span><span></span><span></span>');
    b.type = 'button';
    b.setAttribute('aria-label', 'Menu');
    b.setAttribute('aria-expanded', 'false');
    b.addEventListener('click', function () {
      if (menu && menu.classList.contains('is-open')) closeMenu(); else openMenu();
    });
    bar.appendChild(b);
  }

  /* The packages overlay owns its own button; the menu just presses it. */
  /* ----------------------------------------------------------------------
     What goes in the menu.

     Read off the navbar that is actually on the page, never a list typed in
     here. Hard-coding it is what let Accessories and Tools ship to desktop
     and silently never reach a phone, and it would have done the same to the
     next link anyone added.

     The other pages have no navbar to read, so they get the canonical set
     pointing home — with #how and #contact left as-is, because those panels
     are built on every page and open in place.
     ---------------------------------------------------------------------- */

  var HOME = 'index.html';

  /* Used on every page that has no .nav__links of its own — the product,
     accessories, tools, package and cart pages, where this sheet IS the
     navigation. */
  var FALLBACK = [
    ['Machines',     HOME],
    ['Accessories',  'accessories.html'],
    ['Tools',        'tools.html'],
    ['How It Works', '#how'],
    ['Contact',      '#contact']
  ];

  function iconFor(href, label) {
    var l = label.toLowerCase();
    if (l.indexOf('machine') > -1)  return '🏋️';
    if (l.indexOf('package') > -1)  return '📦';
    if (l.indexOf('accessor') > -1) return '🏋';
    if (l.indexOf('tool') > -1)     return '🧰';
    if (l.indexOf('fit') > -1)      return '📐';
    if (l.indexOf('how') > -1)      return '🧭';
    if (l.indexOf('contact') > -1)  return '💬';
    return '›';
  }

  function menuItems() {
    var links = [].slice.call(document.querySelectorAll('.nav__links .nav__link'));
    if (!links.length) return FALLBACK;
    return links.map(function (a) {
      return [a.textContent.trim(), a.getAttribute('href')];
    });
  }

  /* Where the menu button goes: .nav__act on the home page, .top__act on the
     product pages, and on the cart — whose header ends in an empty spacer
     span holding the layout open — that spacer becomes the slot. */
  function menuSlot() {
    var act = document.querySelector('.nav__act') || document.querySelector('.top__act');
    if (act) return act;

    var top = document.querySelector('.top');
    if (!top) return null;

    act = el('div', 'top__act');
    var last = top.lastElementChild;
    var spacer = last && last.tagName === 'SPAN' &&
                 !last.children.length && !last.textContent.trim();
    if (spacer) top.replaceChild(act, last); else top.appendChild(act);
    return act;
  }

  /* ----------------------------------------------------------------------
     The wordmark in the middle of a sub-page header is a plain <span>, so
     there is no way home from it — every other site puts you home when you
     press the logo. Swapped for a link, keeping its class, its contents and
     its place in the row. The back button is untouched: back and home are
     two different journeys, and both belong there.
     ---------------------------------------------------------------------- */
  function linkLogoHome() {
    var logo = document.querySelector('.top__logo');
    if (!logo || logo.tagName === 'A') return;

    var a = el('a', logo.className, logo.innerHTML);
    a.href = HOME;
    a.setAttribute('aria-label', 'Iron Fit — home');
    logo.parentNode.replaceChild(a, logo);
  }

  /* ----------------------------------------------------------------------
     FOOTER

     There was no <footer> anywhere on the site — eight pages, zero. Nothing
     below the fold said who you are buying from, what the guarantee is, or
     where you deliver, and the only phone number on a sub-page was inside
     a header that collapses to an icon on small phones.

     Built here rather than pasted into eight files so it stays one thing.
     Skipped on the home page, which is a deliberately unscrollable single
     screen — its equivalents are the note strip and the Contact panel.
     ---------------------------------------------------------------------- */
  function buildFooter() {
    if (document.querySelector('.showroom')) return;   /* home: no scroll */
    if (document.querySelector('.ifsf')) return;

    var f = el('footer', 'ifsf');
    f.innerHTML =
      '<div class="ifsf__in">' +

        '<div class="ifsf__col ifsf__col--brand">' +
          '<span class="ifsf__logo">Iron<b>Fit</b></span>' +
          '<p class="ifsf__pitch">Commercial-grade home gym machines, delivered and ' +
            'professionally installed anywhere in Lebanon. You pay cash at the door.</p>' +
        '</div>' +

        '<div class="ifsf__col">' +
          '<h3>Shop</h3>' +
          '<a href="' + HOME + '">Machines</a>' +
          '<a href="bundle.html?fam=famous">Complete packages</a>' +
          '<a href="accessories.html">Bench, bar &amp; plates</a>' +
          '<a href="tools.html">Tool sets</a>' +
        '</div>' +

        '<div class="ifsf__col">' +
          '<h3>How it works</h3>' +
          '<a href="#how">The four steps</a>' +
          '<a href="#contact">Talk to a person</a>' +
          /* These three restate the page's own .trust row and the note strip.
             Worth having on a wide screen where the footer has room; on a
             phone they were pure duplication, so the CSS drops them there. */
          /* "on every machine", not flatly "included": the tool kits carry a
             flat $4 of their own now, and a footer that contradicts the tools
             page is the kind of thing a customer argues about at the door. */
          '<span class="ifsf__restate">We deliver anywhere in Lebanon</span>' +
          '<span class="ifsf__restate">Installation by our own team</span>' +
          '<span class="ifsf__restate">Cash on delivery — no card, no deposit</span>' +
        '</div>' +

        '<div class="ifsf__col">' +
          '<h3>Reach us</h3>' +
          '<a class="ifsf__wa" href="' + WA_URL + '" target="_blank" rel="noopener">' +
            ICON.wa + 'WhatsApp 81 923 182</a>' +
          '<a href="tel:+96181923182">' + ICON.tel + 'Call 81 923 182</a>' +
          '<span>' + ICON.pin + 'Lebanon — nationwide delivery</span>' +
        '</div>' +

      '</div>' +
      '<div class="ifsf__base">' +
        '<span>&copy; ' + new Date().getFullYear() + ' Iron Fit</span>' +
        '<span>Prices in USD · delivery added by region, charged once</span>' +
      '</div>';

    document.body.appendChild(f);
  }

  function buildMenu(howPanel, contactPanel) {
    linkLogoHome();

    var act = menuSlot();
    if (!act) return;

    burger = el('button', 'nav__burger', '<span></span><span></span><span></span>');
    burger.type = 'button';
    burger.setAttribute('aria-label', 'Menu');
    burger.setAttribute('aria-expanded', 'false');
    act.appendChild(burger);

    var rows = menuItems().map(function (item) {
      var label = item[0], href = item[1];
      var go = href === '#how' ? 'how'
             : href === '#contact' ? 'contact'
             : href === '#machines' ? 'machines'
             : '';
      return '<a class="ifsm__link" href="' + href + '"' + (go ? ' data-go="' + go + '"' : '') + '>' +
             '<i aria-hidden="true">' + iconFor(href, label) + '</i>' + label +
             '<em aria-hidden="true">&#8594;</em></a>';
    }).join('');

    /* WhatsApp lives here as well as in the header, and on small phones it
       lives ONLY here — see ifz-sections.css section 9, where the header
       button is dropped below 380px to stop the wordmark colliding with it.
       Losing the shortcut entirely would cost a way for customers to reach
       you, so it moves rather than disappears. */
    var wa =
      '<a class="ifsm__wa" href="' + WA_URL + '" target="_blank" rel="noopener">' +
        ICON.wa + '<span>WhatsApp us</span><b>81 923 182</b>' +
      '</a>';

    menu = el('div', 'ifsm');
    menu.innerHTML =
      '<div class="ifsm__panel">' +
        '<div class="ifsm__grip" aria-hidden="true"></div>' +
        rows +
        wa +
        '<p class="ifsm__foot">Cash on delivery · all Lebanon</p>' +
      '</div>';
    document.body.appendChild(menu);

    burger.addEventListener('click', function () {
      if (menu.classList.contains('is-open')) closeMenu(); else openMenu();
    });

    /* Tapping the dimmed area behind the sheet closes it. */
    menu.addEventListener('click', function (e) {
      if (e.target === menu) closeMenu();
    });

    [].forEach.call(menu.querySelectorAll('[data-go]'), function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var go = a.getAttribute('data-go');
        if (go === 'how')       { openPanel(howPanel); return; }
        if (go === 'contact')   { openPanel(contactPanel); return; }
        closeMenu();
      });
    });
  }

  /* ======================================================================
     INIT
     ====================================================================== */

  /* ======================================================================
     NOTE STRIP → TICKER

     The strip promises delivery, installation and cash on delivery. All three
     do not fit across a phone, and it was being sliced off mid-word. Wrapping
     the contents and cloning them once lets the belt travel exactly one copy's
     width and restart with no seam, so the whole promise gets read.
     Purely additive: desktop hides the clone and centres the original.
     ====================================================================== */

  function buildTicker() {
    var note = document.querySelector('.note');
    if (!note || note.querySelector('.note__belt')) return;

    var run = el('span', 'note__run');
    while (note.firstChild) run.appendChild(note.firstChild);

    var clone = run.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');   /* read once, not twice */

    var belt = el('div', 'note__belt');
    belt.appendChild(run);
    belt.appendChild(clone);
    note.appendChild(belt);
  }

  /* ======================================================================
     ORDER BUTTON ON EACH MACHINE

     Pairs "Order" with the existing "View machine" cue and opens WhatsApp
     with the machine and its price already written in, so a phone visitor can
     buy from the machine itself instead of going to its page first.

     Built at every width; CSS shows it on phones only (on desktop .mch__row
     is display:contents, which dissolves the wrapper and leaves the hover cue
     laid out exactly as it was).
     ====================================================================== */

  /* Read the markup, not the render. textContent glues the words together
     across the name's <br> ("CompactSingle-Stack"), and innerText — which
     would honour it — returns nothing at all while the loading gate still has
     the page hidden, which is exactly when this runs. */
  function flat(node) {
    return node.innerHTML
      .replace(/<br\s*\/?>/gi, ' ')
      .replace(/<[^>]+>/g, '')
      .replace(/&amp;/g, '&')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function buildOrderButtons() {
    [].forEach.call(document.querySelectorAll('.mch'), function (m) {
      var go = m.querySelector('.mch__go');
      var name = m.querySelector('.mch__name');
      var price = m.querySelector('.mch__price');
      if (!go || !name || !price) return;
      if (go.parentNode.classList.contains('mch__row')) return;   /* already done */

      var what = flat(name);

      /* Goes to the machine's own page, where the cash-on-delivery button
         is. It used to open WhatsApp with "I want to order the X" already
         typed, which felt quicker and cost more than it looked: an order
         that arrives as a chat message never passes through the checkout,
         so the Pixel never sees a Purchase and the ads never learn which
         people actually buy. Every order now takes the one road that is
         measured. WhatsApp stays in the header and the menu for questions. */
      var key  = (m.className.match(/\bmch--([a-z0-9-]+)/) || [])[1];
      var page = m.querySelector('.spec__cta');
      var href = (page && page.getAttribute('href')) ||
                 (key && window.IFZU ? window.IFZU('machine.html?m=' + key) : '#');

      var buy = el('a', 'mch__buy', '<span>Order</span><i aria-hidden="true">&rarr;</i>');
      buy.href = href;
      buy.setAttribute('aria-label', 'Order the ' + what + ' — cash on delivery');

      /* The machine itself navigates on tap — ordering must not also fire it. */
      buy.addEventListener('click', function (e) { e.stopPropagation(); });

      var row = el('div', 'mch__row');
      go.parentNode.insertBefore(row, go);
      row.appendChild(go);
      row.appendChild(buy);

      addBundleLink(m, row);
    });
  }

  /* ----------------------------------------------------------------------
     "See it in a bundle" — the upsell from a single machine to a package.

     It used to open the rack and then press that carousel's own dot to land
     on the right package. With the rack gone it is an ordinary link to the
     package page.

     The two machines that come in several plate weights go to the FAMILY —
     ?fam= rather than ?b= — so the package page opens with the weight still
     to be chosen rather than with the smallest one already assumed. The
     compact gym has no plates, so it goes straight to its own package.
     ---------------------------------------------------------------------- */

  var BUNDLE_FOR = {
    'mch--compact':   { href: 'bundle.html?b=compact',     label: 'The One-Machine Gym' },
    'mch--crossover': { href: 'bundle.html?fam=famous',    label: 'The Famous Gym' },
    'mch--smith':     { href: 'bundle.html?fam=smith',     label: 'the Smith packages' }
  };

  function addBundleLink(machine, row) {
    var key = null;
    for (var k in BUNDLE_FOR) { if (machine.classList.contains(k)) { key = k; break; } }
    if (!key) return;

    var target = BUNDLE_FOR[key];
    var link = el('a', 'mch__bundle',
      '<i aria-hidden="true">📦</i><span>See it in a bundle</span><em aria-hidden="true">→</em>');
    link.href = window.IFZU ? window.IFZU(target.href) : target.href;
    link.setAttribute('aria-label', 'See ' + target.label + ', which includes this machine');

    /* the whole card navigates on tap — this must not also fire it */
    link.addEventListener('click', function (e) { e.stopPropagation(); });

    row.parentNode.insertBefore(link, row.nextSibling);
  }

  /* ======================================================================
     PACKAGES, ON PHONES        (styles: ifz-sections.css section 8)

     The packages carousel is left exactly as it is — same card, same doors.
     Two phone-only problems are solved from out here, so ifz-packages.js and
     ifz-packages.css are never touched:

       · the price and "Add to cart" sat 173px below the fold. A pinned bar
         carries them instead. It READS the front card rather than keeping its
         own copy of the prices, so a package's extras are already counted and
         there is no second set of numbers to drift.
       · the swipe did nothing until you let go. The rack now tracks the
         finger, and the carousel's own arrows do the actual paging on release
         — none of its working logic is duplicated.
     ====================================================================== */

  var PHONE = window.matchMedia('(max-width: 860px)');

  function pinnedBar(pk, track) {
    var bar = el('div', 'pkbar',
      '<div class="pkbar__tx"><b></b><div class="pkbar__pr"><i></i><s></s></div></div>' +
      '<button class="pkbar__cta" type="button">Add to cart</button>');
    pk.appendChild(bar);

    var nameEl = bar.querySelector('b');
    var totEl = bar.querySelector('i');
    var wasEl = bar.querySelector('s');
    var cta = bar.querySelector('.pkbar__cta');

    function front() { return track.querySelector('.pkc.is-front'); }

    function sync() {
      var f = front();
      if (!f) return;

      var n = f.querySelector('.pkc__name');
      var total = f.querySelector('.pkc__price b');
      var was = f.querySelector('.pkc__price s');
      var cardCta = f.querySelector('.pkc__cta');

      nameEl.textContent = n ? n.textContent.trim() : '';
      totEl.textContent = total ? total.textContent.trim() : '';
      wasEl.textContent = was ? was.textContent.trim() : '';
      wasEl.hidden = !was;

      /* The plate-tier group card is a chooser, not a package. Offering
         "Add to cart" under it would put a box in the cart before anybody
         had said how many plates they wanted — so the bar asks the question
         instead, and tapping it opens the four options. */
      if (f.classList.contains('pkc--group')) {
        /* No price. The group card covers four boxes at four prices, and
           printing the cheapest one beside "The Famous Gym" reads as THE
           price — somebody would tap through expecting $899 and meet
           $1,049. The number belongs on the tier they actually pick. */
        totEl.textContent = '';
        wasEl.textContent = '';
        wasEl.hidden = true;
        cta.classList.remove('is-added');
        cta.classList.add('pkbar__cta--choose');
        cta.textContent = 'Choose your plates →';
        return;
      }
      cta.classList.remove('pkbar__cta--choose');

      var added = f.classList.contains('is-added') ||
                  !!(cardCta && cardCta.classList.contains('is-added'));
      cta.classList.toggle('is-added', added);
      cta.textContent = added ? 'Added! View cart →' : 'Add to cart';
    }

    /* The card's own buy button is desktop-only now (the card leads to the
       package page instead), so buy through the card's ifzAdd — the same
       call that button makes — and fall back to clicking it if it is there. */
    cta.addEventListener('click', function () {
      var f = front();
      if (!f) return;
      if (typeof f.ifzAdd === 'function') f.ifzAdd();
      else {
        var c = f.querySelector('.pkc__cta');
        if (c) c.click();
      }
      setTimeout(sync, 60);
    });

    /* is-front moves as the carousel turns, and the total's text changes as
       extras are ticked. Watch the rack for both rather than guessing when to
       refresh. The bar lives outside the rack, so writing to it cannot
       retrigger this. */
    if (window.MutationObserver) {
      new MutationObserver(sync).observe(track, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }
    track.addEventListener('click', function () { setTimeout(sync, 80); }, true);

    sync();
  }

  function liveDrag(pk, track, stage) {
    var prev = pk.querySelector('.pkcar__nav--prev');
    var next = pk.querySelector('.pkcar__nav--next');
    if (!prev || !next) return;

    var x0 = null, dx = 0, w = 1, moved = false, movedAt = 0;

    /* Every width. Desktop keeps everything it had: the hover-bend runs off
       pointermove with no button down, which this never intercepts, and
       clicking a side card to bring it forward is a click, not a drag. */
    function live() { return true; }

    /* Capture phase with propagation stopped, so the carousel's own
       jump-on-release handler never sees these and cannot page a second time
       on top of this one. */
    stage.addEventListener('pointerdown', function (e) {
      if (!live() || e.button) return;
      e.stopPropagation();
      x0 = e.clientX;
      dx = 0;
      moved = false;
      w = stage.clientWidth || 1;
      track.classList.add('is-held');
    }, true);

    stage.addEventListener('pointermove', function (e) {
      if (!live() || x0 === null) return;
      e.stopPropagation();
      dx = e.clientX - x0;
      if (Math.abs(dx) > 6) moved = true;
      track.style.transform = 'translateX(' + (dx * 0.55).toFixed(1) + 'px)';
    }, true);

    function release(e) {
      if (x0 === null) return;
      if (live()) e.stopPropagation();
      var travelled = dx;
      x0 = null;
      movedAt = Date.now();
      track.classList.remove('is-held');
      track.style.transform = '';
      if (Math.abs(travelled) > w * 0.13) (travelled < 0 ? next : prev).click();
    }
    window.addEventListener('pointerup', release, true);
    window.addEventListener('pointercancel', release, true);

    /* A drag must not also count as picking one of the side cards.

       The window matters. The click being suppressed is the one the browser
       synthesises at the end of a drag, which lands immediately. Suppressing
       on the flag alone would eat the NEXT deliberate press instead whenever
       no such click ever arrived — and the pinned bar buys by clicking the
       front card's own button, which is inside this stage, so "Add to cart"
       would silently do nothing after any swipe. */
    stage.addEventListener('click', function (e) {
      if (!live() || !moved) return;
      moved = false;
      if (Date.now() - movedAt > 350) return;
      e.stopPropagation();
      e.preventDefault();
    }, true);
  }

  /* ======================================================================
     THE BUNDLE OFFER, ON A MACHINE'S OWN PAGE

     A customer reading about one machine has no idea it comes in a package
     that throws in a bench, a bar and plates for less than buying them
     separately. This puts that offer directly under the price.

     Every number is read from window.IFZ_BUNDLES — the same data the
     packages screen and bundle.html use — so there is no second copy of a
     price here to drift out of step.
     ====================================================================== */

  /* What each product page is called inside a bundle's contents list. The
     bundles are searched for it — nothing here hard-codes which bundle wins,
     so adding a package or moving an item between packages needs no change. */
  var IN_BUNDLE = {
    compact:   'Compact Single-Stack',
    crossover: 'Dual Cable Crossover',
    smith:     'Multifunctional Smith',
    bench:     'Adjustable Bench',
    bar:       'Olympic Bar',
    plates:    'Rubber Olympic Plates'
    /* The dumbbell set was removed from the range on 2026-09-11 and has no
       key here any more. */
  };

  function money(n) { return '$' + n.toLocaleString('en-US'); }

  function listOut(names) {
    return names.slice(0, 3).join(', ').replace(/,([^,]*)$/, ' and$1');
  }

  function buildMachineBundle() {
    var promise = document.querySelector('.promise');
    if (!promise || document.querySelector('.mbun')) return;

    var all = window.IFZ_BUNDLES;
    if (!all || !all.length) return;

    /* Which machine this page is.

       This used to read ?m= only, which is how the static build names a
       machine (machine.html?m=smith). A Shopify product URL carries no such
       parameter, so it fell through to the default and EVERY machine page
       offered the crossover's package — the Smith page included, which is
       how a Smith machine ended up advertising a crossover gym.

       The theme states the key outright in IFZ_PRODUCT_KEY, so that comes
       first and ?m= remains the fallback for the static build. */
    var m = window.IFZ_PRODUCT_KEY ||
            (window.location.search.match(/[?&]m=([a-z0-9-]+)/i) || [])[1] ||
            'crossover';
    var needle = IN_BUNDLE[m];
    if (!needle) return;

    /* Cheapest package that contains this item AND actually saves money.
       A package priced the same as the thing itself is not an offer, so it
       is skipped rather than dressed up as one. */
    var best = null, bestItem = null;
    all.forEach(function (b) {
      if (!b.was || b.was <= b.price) return;
      var hit = null;
      (b.items || []).forEach(function (i) {
        if (!hit && i.name && i.name.indexOf(needle) > -1) hit = i;
      });
      if (hit && (!best || b.price < best.price)) { best = b; bestItem = hit; }
    });
    if (!best) return;

    var save = best.was - best.price;
    var others = best.items
      .filter(function (i) { return i !== bestItem; })
      .map(function (i) { return i.name; });

    /* The machine is the first thing in its package; everything else is a
       part that the package already contains. Two different sentences. */
    var isTheMachine = best.items[0] === bestItem;
    var line = !others.length ? ''
      : isTheMachine
        ? 'Adds ' + listOut(others) + ', delivered and installed together.'
        : 'Already included, together with ' + listOut(others) + '.';

    /* SIBLING TIERS.

       Some packages come in several plate weights — the same gym with 20,
       40, 60 or 80 kg in the box. The loop above picks the CHEAPEST that
       saves money, which meant this box always sent people to the 20 kg one
       and the other three were invisible from a machine page.

       When there is more than one, this stops pretending there is a single
       answer: it quotes the entry price, says how many options there are,
       and opens the chooser rather than committing the visitor to the
       smallest box before they knew the others existed. */
    var tiers = all.filter(function (b) {
      return b.machine === best.machine && b.plateKg != null;
    });

    var box = el('a', 'mbun');

    if (tiers.length > 1) {
      var lo = Math.min.apply(null, tiers.map(function (b) { return b.price; }));
      var kgs = tiers.map(function (b) { return b.plateKg; }).sort(function (a, b) { return a - b; });

      /* 'Save up to' has to mean the biggest saving in the family, not the
         cheapest tier's. The save above is the one belonging to the entry
         package — printing that after the words 'up to' understates the
         range by the width of it, which on the crossover is $30. */
      var topSave = tiers.reduce(function (m, b) {
        return (b.was && b.was - b.price > m) ? b.was - b.price : m;
      }, 0) || save;

      /* STRAIGHT TO THE PACKAGE PAGE.

         This has been three different things. It sent people to the home
         page with a flag so the rack could raise a chooser over there; then
         it raised that chooser in place. Either way the plate weight was
         answered in a floating box, and answering it dropped you onto a
         page you then had to read from the top.

         The package page asks it itself now, as its first step, with the
         package underneath already showing what the answer buys. ?fam=
         rather than ?b= is what says "the family, weight not yet chosen" —
         land on ?b=famous and you have been handed the 20 kg one. */
      var famKey = /^smith/.test(best.id) ? 'smith' : 'famous';
      box.href = 'bundle.html?fam=' + famKey;
      /* "20, 40, 60 or 80" — the last one is spoken, not listed, so pull it
         off BEFORE joining the rest. Joining first and popping after prints
         the last weight twice. */
      var lastKg = kgs.pop();
      var kgList = kgs.length ? kgs.join(', ') + ' or ' + lastKg : String(lastKg);

      /* The "adds" line is built from the CHEAPEST tier, so it names its
         plates — "adds a bench, a bar and 20 KG plates" immediately before
         offering four weights reads as a contradiction. The plates get
         their own sentence here, so they come out of the list. */
      var addsNoPlates = others
        .filter(function (n) { return !/plate/i.test(n); });
      var line2 = addsNoPlates.length
        ? (isTheMachine ? 'Adds ' + listOut(addsNoPlates) + ', delivered and installed together.'
                        : 'Already included, together with ' + listOut(addsNoPlates) + '.')
        : '';

      box.innerHTML =
        '<span class="mbun__save">💰 Save up to ' + money(topSave) + '</span>' +
        '<b class="mbun__name">' + best.name + ' — from ' + money(lo) + '</b>' +
        '<span class="mbun__adds">' + line2 +
          ' Choose ' + kgList + ' kg of plates.' +
        '</span>' +
        '<em class="mbun__go">See the ' + tiers.length + ' options →</em>';
      promise.parentNode.insertBefore(box, promise.nextSibling);
      return;
    }

    box.href = best.href || ('bundle.html?b=' + best.id);
    box.innerHTML =
      '<span class="mbun__save">💰 Save ' + money(save) + '</span>' +
      '<b class="mbun__name">' + best.name + ' — ' + money(best.price) + '</b>' +
      (line ? '<span class="mbun__adds">' + line + '</span>' : '') +
      '<em class="mbun__go">See the bundle →</em>';

    promise.parentNode.insertBefore(box, promise.nextSibling);
  }

  function buildPackagesPhone() {
    var pk = document.getElementById('pk');
    if (!pk) return true;                          /* no packages on this page */
    if (pk.querySelector('.pkbar')) return true;   /* already built */

    var track = pk.querySelector('.pkcar__track');
    var stage = pk.querySelector('.pkcar__stage');
    if (!track || !stage) return false;            /* carousel not up yet */

    pinnedBar(pk, track);
    liveDrag(pk, track, stage);
    return true;
  }

  function init() {
    buildTicker();
    buildOrderButtons();
    buildMachineBundle();

    /* The carousel is now built the first time the overlay is opened, which
       can be long after this runs — so listen for it instead of polling for a
       few seconds and giving up. The immediate call still covers the case
       where it was already built. */
    document.addEventListener('ifz:packages-ready', function () { buildPackagesPhone(); });

    if (!buildPackagesPhone()) {
      var tries = 0;
      var poll = setInterval(function () {
        if (buildPackagesPhone() || ++tries > 40) clearInterval(poll);
      }, 100);
    }

    var how = buildHow();
    var contact = buildContact();
    document.body.appendChild(how);
    document.body.appendChild(contact);

    wirePanel(how);
    wirePanel(contact);

    buildMenu(how, contact);
    buildFooter();

    /* The menu has to stay reachable from inside the overlays that cover the
       navbar — both panels, and the packages overlay on the home page. */
    addOverlayBurger(how.querySelector('.ifs__bar'));
    addOverlayBurger(contact.querySelector('.ifs__bar'));
    var pkHd = document.querySelector('.pk .pk__hd');
    if (pkHd) addOverlayBurger(pkHd);

    /* Delegated rather than bound to the links that happen to exist right
       now — the navbar is still being reworked, and a rebuilt header must
       not quietly lose its How It Works and Contact links.

       #build used to be handled here too, sending "Build Your Gym" into the
       packages overlay. There is no overlay to send it to now. */
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;

      var h = a.getAttribute('href');
      if (a.hasAttribute('data-go')) return;          /* the menu handles its own */

      if (h === '#how')     { e.preventDefault(); openPanel(how); return; }
      if (h === '#contact') { e.preventDefault(); openPanel(contact); return; }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = document.querySelector('.ifs.is-open');
      if (open) { closePanel(open); return; }
      if (menu && menu.classList.contains('is-open')) closeMenu();
    });

    /* Deep link: /index.html#contact opens the panel on arrival.
       Delayed so it lands after the loading gate has lifted.

       #packages used to be handled here too, on the same 2.4-second timer —
       which is why Packages from another page meant watching the homepage
       for two and a half seconds before the rack appeared. ifz-packages.js
       owns that arrival now and opens it at once. Leaving this branch in as
       well would fire the wipe animation a second time on top of an overlay
       that is already up. */
    var h = window.location.hash;
    if (h === '#how' || h === '#contact') {
      setTimeout(function () { openPanel(h === '#how' ? how : contact); }, 2400);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
